"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Picker = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _SearcherDropdown = _interopRequireDefault(require("@lt/components/components/SearcherDropdown"));

var _TouristsPicker = _interopRequireDefault(require("@lt/components/components/TouristsPicker"));

var _styles = require("@lt/components/components/DurationTrip/styles");

var _DropdownIndicator = _interopRequireDefault(require("./components/DropdownIndicator"));

var _constants = require("./constants");

var _constants2 = require("../../constants");

var _touristPickerModule = _interopRequireDefault(require("./touristPicker.module.css"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _excluded = ["isWizard", "isMobile", "className", "variant", "isOpenInitial", "setBodyLocked", "searchType", "isWhiteLabel"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Выбор туристов
 */
var Picker = function Picker(props) {
  var _clsx;

  var isWizard = props.isWizard,
      isMobile = props.isMobile,
      className = props.className,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      isOpenInitial = props.isOpenInitial,
      setBodyLocked = props.setBodyLocked,
      searchType = props.searchType,
      _props$isWhiteLabel = props.isWhiteLabel,
      isWhiteLabel = _props$isWhiteLabel === void 0 ? false : _props$isWhiteLabel,
      otherProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react["default"].createElement(StyledTouristsPicker, {
    $isWizard: isWizard,
    $isMobile: isMobile,
    className: (0, _clsx2["default"])(_touristPickerModule["default"].touristsPicker, className, (_clsx = {}, _defineProperty(_clsx, _touristPickerModule["default"].touristsPickerMobile, isMobile && !isWizard), _defineProperty(_clsx, _touristPickerModule["default"].touristsPickerDesktop, !isMobile), _defineProperty(_clsx, _touristPickerModule["default"].leftBorder, !isMobile), _defineProperty(_clsx, _touristPickerModule["default"].touristsPickerWizard, isWizard), _defineProperty(_clsx, _touristPickerModule["default"].touristsPickerHotel, variant === 'hotel'), _defineProperty(_clsx, _touristPickerModule["default"].touristsPickerDesktopHotelSearch, !isMobile && searchType === _constants2.SEARCH_TYPE_NAMES.HOTEL), _clsx)),
    $variant: variant
  }, isMobile && !isWizard && /*#__PURE__*/_react["default"].createElement(_styles.MobileLabel, {
    $isWhiteLabel: isWhiteLabel,
    $variant: variant
  }, _constants.touristsPlaceholder), /*#__PURE__*/_react["default"].createElement(_TouristsPicker["default"], _extends({}, otherProps, {
    setBodyLocked: setBodyLocked,
    isMobile: isMobile,
    isMobileInput: isMobile,
    CustomDropdownIndicator: _DropdownIndicator["default"],
    isOpenInitial: isOpenInitial,
    isWhiteLabel: isWhiteLabel
  })));
};

exports.Picker = Picker;

var StyledTouristsPicker = _styledComponents["default"].div.withConfig({
  displayName: "TouristsPicker__StyledTouristsPicker",
  componentId: "sc-1ta9jvd-0"
})(["", "{border-radius:var(--border-radius);box-shadow:none;", " ", " &:hover{border:0;box-shadow:none;}}"], _SearcherDropdown["default"].Input, function (_ref) {
  var $isMobile = _ref.$isMobile,
      $isWizard = _ref.$isWizard;
  return $isMobile && !$isWizard && (0, _styledComponents.css)(["height:48px;"]);
}, function (_ref2) {
  var $variant = _ref2.$variant;
  return $variant === 'hotel' && (0, _styledComponents.css)(["background-color:var(--background);"]);
});